import {
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@facade/components/ui";

import { ProjectSidebarTabProps } from "./ProjectSidebarTab.types";
import { cn } from "@facade/lib/utils";

export function ProjectSidebarTab({
  value,
  icon: Icon,
  label,
  open,
}: ProjectSidebarTabProps) {
  return (
    <TabsTrigger
      value={value}
      className={cn(
        "relative h-8 overflow-hidden rounded-md px-2",
        "justify-start gap-3",
        "transition-[background-color,color,margin] duration-100",
        "data-[state=active]:bg-accent data-[state=active]:text-accent-foreground",
        !open && "justify-start items-center max-w-8.5 ms-1",
      )}
    >
      <Icon className="size-4 shrink-0" />
      <span
        className={cn(
          "min-w-0 max-w-40 truncate whitespace-nowrap",
          "transition-[opacity,transform,max-width] duration-250 ease-[cubic-bezier(0.22,1,0.36,1)]",
          open ? "opacity-100" : "max-w-0 opacity-0",
        )}
      >
        {label}
      </span>
      <Tooltip>
        <TooltipTrigger
          className={cn(open && "pointer-events-none hidden")}
          asChild
        >
          <span className="absolute inset-0" />
        </TooltipTrigger>
        <TooltipContent side="right">{label}</TooltipContent>
      </Tooltip>
    </TabsTrigger>
  );
}
